import { render, staticRenderFns } from "./WorkspaceMemberForm.vue?vue&type=template&id=faff1c3a&scoped=true"
import script from "./WorkspaceMemberForm.vue?vue&type=script&lang=js"
export * from "./WorkspaceMemberForm.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceMemberForm.vue?vue&type=style&index=0&id=faff1c3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faff1c3a",
  null
  
)

export default component.exports